import { FC, MouseEvent, useContext, useState } from 'react'
import { Menu, MenuItem } from '@material-ui/core'
import gql from 'graphql-tag'
import styled, { css } from 'styled-components'
import {
  ActivityOrderField,
  OrderDirection,
  RecruitListOrderBy_ActivityConnectionFragment,
} from 'generated/graphql'
import { RecruitListScreenContext } from '@app.feature/recruitList/context'
import { Button } from 'components/custom-material-ui'
import { ORDER_TEXT } from 'constants/typeText'
import ExpandMoreIcon from 'svgIcons/ExpandMore'

gql`
  fragment RecruitListOrderBy_activityConnection on ActivityConnection {
    totalCount
  }
`

interface IFRecruitListOrderByProps {
  activityConnection?: RecruitListOrderBy_ActivityConnectionFragment | null
}

export const MENU_LIST: Array<ActivityOrderField> = [
  ActivityOrderField.RECENT,
  ActivityOrderField.RECRUIT_CLOSE_AT,
  ActivityOrderField.VIEW_COUNT,
  ActivityOrderField.SCRAP_COUNT,
]

const RecruitListOrderBy: FC<IFRecruitListOrderByProps> = ({
  activityConnection,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { state, dispatch } = useContext(RecruitListScreenContext)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const setActivityOrderDirectionByField = (
    activityOrderField: ActivityOrderField,
  ) => {
    switch (activityOrderField) {
      case ActivityOrderField.RECRUIT_CLOSE_AT:
        return OrderDirection.ASC
      default:
        return OrderDirection.DESC
    }
  }

  const handleMenuItemClick = (activityOrderField: ActivityOrderField) => {
    dispatch({
      type: 'ORDER_BY_UPDATE',
      orderBy: {
        field: activityOrderField,
        direction: setActivityOrderDirectionByField(activityOrderField),
      },
    })
    handleClose()
  }

  return (
    <StyledWrapper>
      <p className="search-count-typo" data-testid="activity-list-total-count">
        검색 결과 {activityConnection?.totalCount || '0'}건
      </p>
      <Button
        data-testid="activity-list-orderBy-button"
        className="button-orderby"
        aria-controls="order-menu"
        aria-haspopup="true"
        onClick={handleClick}
        classes={{
          endIcon: 'icon-button-end',
        }}
        endIcon={<ExpandMoreIcon className="icon-expand-more" />}
      >
        {state?.orderBy?.field ? ORDER_TEXT[state.orderBy.field] : ''}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {MENU_LIST.map((activityOrderFieldKey) => (
          <MenuItem
            data-testid={`activity-list-orderBy-${activityOrderFieldKey}`}
            selected={activityOrderFieldKey === state?.orderBy?.field}
            key={activityOrderFieldKey}
            onClick={() => handleMenuItemClick(activityOrderFieldKey)}
          >
            {ORDER_TEXT[activityOrderFieldKey]}
          </MenuItem>
        ))}
      </Menu>
    </StyledWrapper>
  )
}

export default RecruitListOrderBy

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-left: 0;
    margin-right: 0;

    .search-count-typo {
      font-size: 16px;
      margin-bottom: 20px;
      font-weight: 400;
    }
    .button-orderby {
      background-color: transparent;
      font-weight: 500;
      &:hover {
        background-color: transparent;
      }
    }
    .icon-button-end {
      margin-left: 10px;
    }
    .icon-expand-more {
      width: 14px;
    }

    ${theme.isMobile &&
    css`
      margin-left: 20px;
      margin-right: 11px;
      .search-count-typo {
        white-space: nowrap;
        margin-bottom: 12px;
        font-size: 12px;
        color: #999;
      }
      .button-orderby {
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 12px;
      }
    `}
  `}
`
